import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import { FaExclamation } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import {
  FooterBotoes,
  IconeCirculo,
  ObservacaoContainer,
  TextoDescricao,
  TituloComIcone,
} from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: (observacao: string) => void;
}

export function ModalValidarLote({ show, handleClose, onConfirm }: IProps) {
  const [observacao, setObservacao] = useState("");

  useEffect(() => {
    if (!show) setObservacao("");
  }, [show]);

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={
        <TituloComIcone>
          <IconeCirculo>
            <FaExclamation />
          </IconeCirculo>
          Validar lote
        </TituloComIcone>
      }
      centered
      footer
      footerTools={
        <FooterBotoes>
          <PrimaryButton outline variante="primary" onClick={handleClose}>
            Cancelar
          </PrimaryButton>
          <PrimaryButton onClick={() => onConfirm(observacao)}>Validar</PrimaryButton>
        </FooterBotoes>
      }
    >
      <TextoDescricao>Deseja validar o lote selecionado?</TextoDescricao>
      <ObservacaoContainer>
        <Form.Group>
          <Form.Label>
            Observação (será adicionada a todos os lotes selecionados)
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Insira uma observação"
            value={observacao}
            onChange={(e) => setObservacao(e.target.value)}
          />
        </Form.Group>
      </ObservacaoContainer>
    </ModalCustom>
  );
}
